// Promo Builder Turbo JS - Direct Integration with Turbo Theme
// This version finds and uses Turbo's actual cart update mechanism

(function() {
  'use strict';

  // First, let's find out what Turbo theme uses
  console.log('Debugging Turbo cart system...');
  console.log('ajaxCart available?', typeof ajaxCart !== 'undefined');
  console.log('buildMiniCart available?', typeof buildMiniCart !== 'undefined');
  console.log('jQuery available?', typeof jQuery !== 'undefined');
  console.log('theme object available?', typeof theme !== 'undefined' && theme);

  // PASTE THIS FUNCTION INTO promo-builder-turbo.js

function buildMiniCart(cart) {
  const $cartItemsContainer = jQuery('.js-cart_items');
  const $cartSubtotalContainer = jQuery('.js-cart_subtotal');
  const $emptyCartMessage = jQuery('.js-empty-cart__message');
  const $cartForm = jQuery('[data-cart-form="mini-cart"]');
  
  // You might need to find this in your theme.liquid if it's not on the body tag
  const moneyFormat = jQuery('body').data('money-format') || '${{amount}}'; 

  $cartItemsContainer.empty();

  if (cart.item_count === 0) {
    $cartForm.addClass('hidden');
    $emptyCartMessage.removeClass('hidden');
    return;
  }
  
  $cartForm.removeClass('hidden');
  $emptyCartMessage.addClass('hidden');

  let itemsHtml = '';
  cart.items.forEach((item, index) => {
    const line_id = index + 1;
    // Note: Shopify.formatMoney might not be available. A simple replacement is used here.
    const itemPrice = (item.final_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
    const imageUrl = item.image ? item.image.replace(/(\.[^.]*)$/, "_compact$1") : '';

    itemsHtml += `
      <li class="mini-cart__item clearfix" data-cart-item data-line-id="${line_id}" data-variant-id="${item.id}">
        <a href="${item.url}"><div class="cart_image"><img src="${imageUrl}" alt="${item.title}" /></div></a>
        <div class="mini-cart__item--content">
          <div class="mini-cart__item__title">
            <div class="item_title"><a href="${item.url}">${item.title}</a></div>
            <strong class="right price"><span class="money">${itemPrice}</span></strong>
          </div>
          <div class="left product-quantity-box"><span>Qty: ${item.quantity}</span></div>
        </div>
        <a href="/cart/change?line=${line_id}&quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${line_id}"><span class="remove-icon"></span></a>
      </li>
    `;
  });
  $cartItemsContainer.html(itemsHtml);

  const subtotalPrice = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
  const subtotalHtml = `<span class="right"><span class="money">${subtotalPrice}</span></span><span>Subtotal</span>`;
  $cartSubtotalContainer.html(subtotalHtml);
};
  
  document.addEventListener('DOMContentLoaded', function() {
    initializePromoBuilder();
  });

  function initializePromoBuilder() {
    bindQuantityButtons();
    bindVariantSelectors();
    bindAddToCartButtons();
    bindBundleButton();
  }

  function bindQuantityButtons() {
    document.querySelectorAll('.promo-builder .quantity-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        if (input) input.stepUp();
      });
    });
    
    document.querySelectorAll('.promo-builder .quantity-minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentElement.querySelector('.quantity-input');
        if (input) input.stepDown();
      });
    });
  }

  function bindVariantSelectors() {
    document.querySelectorAll('.promo-builder .variant-selector').forEach(function(selector) {
      updateVariantPrice(selector);
      selector.addEventListener('change', function() {
        updateVariantPrice(this);
        updateButtonVariant(this);
      });
    });
  }

  function updateVariantPrice(selector) {
    var selectedOption = selector.options[selector.selectedIndex];
    if (!selectedOption) return;
    
    var price = selectedOption.getAttribute('data-price');
    var priceContainerId = selector.getAttribute('data-price-container');
    
    if (price && priceContainerId) {
      var priceContainer = document.querySelector(priceContainerId);
      if (priceContainer) priceContainer.textContent = price;
    }
  }

  function updateButtonVariant(selector) {
    var productCard = selector.closest('.product-card');
    if (!productCard) return;
    
    var button = productCard.querySelector('.add-to-cart-btn');
    if (button) button.setAttribute('data-variant-id', selector.value);
  }

  function bindAddToCartButtons() {
    document.querySelectorAll('.promo-builder .add-to-cart-btn').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        handleAddToCart(this);
      });
    });
  }

  function bindBundleButton() {
    var bundleButton = document.querySelector('.promo-builder #add-all-to-cart');
    if (bundleButton) {
      bundleButton.addEventListener('click', function(e) {
        e.preventDefault();
        handleBundleAdd(this);
      });
    }
  }

  function handleAddToCart(button) {
    var productCard = button.closest('.product-card');
    var variantId = button.getAttribute('data-variant-id');
    var quantity = 1;
    
    if (productCard) {
      var variantSelector = productCard.querySelector('.variant-selector');
      if (variantSelector && variantSelector.value) {
        variantId = variantSelector.value;
      }
      
      var quantityInput = productCard.querySelector('.quantity-input');
      if (quantityInput) {
        quantity = parseInt(quantityInput.value) || 1;
      }
    }
    
    if (!variantId) {
      alert('Please select a product variant');
      return;
    }
    
    // Use Turbo's exact method if available
    if (typeof ajaxCart !== 'undefined' && ajaxCart.add) {
      console.log('Using ajaxCart.add method');
      ajaxCart.add(variantId, quantity);
      updateButtonState(button, 'success', 'Added!');
      return;
    }
    
    // Otherwise use jQuery AJAX like Turbo expects
    if (typeof jQuery !== 'undefined') {
      console.log('Using jQuery AJAX method');
      
      var originalText = button.querySelector('.cart-text').textContent;
      updateButtonState(button, 'loading', 'Adding...');
      
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: variantId
        },
        dataType: 'json',
        success: function(item) {
          console.log('Item added:', item);
          updateButtonState(button, 'success', 'Added!');
          
          // Trigger all possible Turbo cart update methods
          if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
            console.log('Calling ajaxCart.load()');
            ajaxCart.load();
          }
          
          // Get fresh cart and trigger events
          jQuery.getJSON('/cart.js', function(cart) {
            console.log('Cart updated:', cart);
            
            // Update cart count
            $('.cart_count').text(cart.item_count);
            
            // Try all possible cart rebuild methods
            if (typeof buildMiniCart === 'function') {
              console.log('Calling buildMiniCart()');
              buildMiniCart(cart);
            }
            
            // Trigger all possible events
            jQuery(document).trigger('ajaxCart:success');
            jQuery(document).trigger('ajaxCart:cartUpdated', cart);
            jQuery(document).trigger('cart:updated', [cart]);
            jQuery(document).trigger('cart.requestComplete', [cart]);
            jQuery(document.body).trigger('added.ajaxProduct');
            
            // Try to open cart drawer
            if ($('#header .cart-container').length) {
              $('#header .cart-container').addClass('active_link');
            }
          });
          
          setTimeout(function() {
            updateButtonState(button, '', originalText);
          }, 2000);
        },
        error: function(XMLHttpRequest, textStatus) {
          console.error('Error adding to cart:', textStatus);
          updateButtonState(button, '', originalText);
          alert('Error adding to cart');
        }
      });
      return;
    }
    
    // Fallback to fetch
    console.log('Using fetch fallback');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    
    var originalText = button.querySelector('.cart-text').textContent;
    updateButtonState(button, 'loading', 'Adding...');
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      console.log('Item added via fetch:', item);
      updateButtonState(button, 'success', 'Added!');
      forceCartRefresh();
      setTimeout(() => updateButtonState(button, '', originalText), 2000);
    })
    .catch(error => {
      console.error('Error:', error);
      updateButtonState(button, '', originalText);
      alert('Error adding to cart');
    });
  }

  function handleBundleAdd(button) {
    var bundleProducts = button.getAttribute('data-bundle-products');
    if (!bundleProducts) return;
    
    var handles = bundleProducts.split(',').filter(h => h.trim());
    var originalText = button.querySelector('.cart-text').textContent;
    
    updateButtonState(button, 'loading', 'Adding all...');
    
    // Get all variant IDs first
    Promise.all(handles.map(handle => 
      fetch(`/products/${handle.trim()}.js`)
        .then(r => r.json())
        .then(product => {
          var variant = product.variants.find(v => v.available);
          if (!variant) throw new Error(`No variant for ${product.title}`);
          return { id: variant.id, quantity: 1 };
        })
    ))
    .then(items => {
      // Add all items at once if possible
      if (typeof jQuery !== 'undefined') {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: items }),
          dataType: 'json',
          contentType: 'application/json',
          success: function() {
            updateButtonState(button, 'success', 'All added!');
            if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
              ajaxCart.load();
            } else {
              forceCartRefresh();
            }
            setTimeout(() => updateButtonState(button, '', originalText), 2000);
          },
          error: function() {
            alert('Error adding bundle');
            updateButtonState(button, '', originalText);
          }
        });
      } else {
        // Fallback
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(() => {
          updateButtonState(button, 'success', 'All added!');
          forceCartRefresh();
          setTimeout(() => updateButtonState(button, '', originalText), 2000);
        })
        .catch(() => {
          alert('Error adding bundle');
          updateButtonState(button, '', originalText);
        });
      }
    })
    .catch(error => {
      console.error('Bundle error:', error);
      alert('Error adding bundle');
      updateButtonState(button, '', originalText);
    });
  }

  function updateButtonState(button, state, text) {
    button.classList.remove('loading', 'success', 'error');
    if (state) button.classList.add(state);
    
    var cartText = button.querySelector('.cart-text');
    if (cartText && text) cartText.textContent = text;
    
    button.disabled = state === 'loading';
  }

  function forceCartRefresh() {
    console.log('Force refreshing cart...');
    
    // Method 1: Direct AJAX cart load
    if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
      ajaxCart.load();
      return;
    }
    
    // Method 2: jQuery get cart and rebuild
    if (typeof jQuery !== 'undefined') {
      jQuery.getJSON('/cart.js', function(cart) {
        $('.cart_count').text(cart.item_count);
        
        if (typeof buildMiniCart === 'function') {
          buildMiniCart(cart);
        }
        
        // Load mini cart HTML directly
        jQuery.get('/cart?view=mini', function(html) {
          $('.js-cart_items, .cart__items').each(function() {
            var $temp = $('<div>').html(html);
            var $newContent = $temp.find('.js-cart_items, .cart__items').first();
            if ($newContent.length) {
              $(this).html($newContent.html());
            }
          });
        });
      });
      return;
    }
    
    // Method 3: Vanilla JS fallback
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart_count').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  // Log what's available for debugging
  window.promoBuilderDebug = function() {
    console.log('=== Turbo Cart Debug ===');
    console.log('ajaxCart:', typeof ajaxCart !== 'undefined' ? ajaxCart : 'not found');
    console.log('buildMiniCart:', typeof buildMiniCart);
    console.log('jQuery:', typeof jQuery);
    console.log('theme:', typeof theme !== 'undefined' ? theme : 'not found');
    
    if (typeof jQuery !== 'undefined') {
      console.log('jQuery events:', jQuery._data(document, 'events'));
    }
  };

  console.log('Promo Builder initialized. Run promoBuilderDebug() in console for diagnostics.');
})();